/* Kendo grid view html cell (render html content) */

import * as _ from 'lodash';
import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { Formatters } from '../common/formatters';

export default class CellDropDown extends React.Component<any, any> {
    public render() {
        const { dataItem, field, recordEditingField, handleDropDownChange, dropdownData, ...rest } = this.props;

        const dataValue = _.get(dataItem, field);
        const isEditing = Formatters.getBool(dataItem, recordEditingField);

        let result = (isEditing) ? (
            <td className="lookup-tables-table-dropdown-cell-edit">
                <div className="lookup-tables-table-dropdown-cell-container">
                    <DropDownList
                        onChange={handleDropDownChange}
                        value={dropdownData.find(c => String(c.text) === String(dataValue))}
                        data={dropdownData}
                        textField="text"
                    />
                </div>
            </td>
        ) : (
            <td className="lookup-tables-table-dropdown-cell-view">
                <div className="lookup-tables-table-dropdown-cell-container">
                    {dataValue}
                </div>
            </td>
        );

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/lookup-tables/cell-dropdown.tsx